import React, { useState } from "react";

import FilePlus from "../../../utils/icons/FilePlus";
import Slider from "../../../utils/Slider";

export default function OpAudioVolume({
  valid,
  labelButton,
  message,
  onSubmit,
}: {
  valid: boolean;
  labelButton?: string;
  message: string;
  onSubmit: Function;
}) {
  const [volume, setVolume] = useState(1);

  return valid ? (
    <>
      <div className="center">{volume}</div>
      <Slider
        min={0}
        max={10}
        step={0.1}
        defaultValues={[1]}
        onChange={(values) => {
          setVolume(values[0]);
        }}
      />
      <p className="mb1 mt1 tac fz08">
        Set the new volume level. 0 means turning the volume off, 1 is the
        current value.
      </p>
      <div className="center mt1">
        <button
          disabled={!isNumber(volume)}
          className="secondary"
          onClick={() =>
            onSubmit({
              volume,
            })
          }
        >
          {labelButton}
        </button>
      </div>
    </>
  ) : (
    <p className="mb1 mt1 tac fz08 with-icon">
      <FilePlus size={16} className="ib" /> {message}
    </p>
  );
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}
